import React from 'react'

import { Button } from '@/components'
import { StructureDto } from '@/endpoints/models'
import { useAppContext } from '@/hooks'

export interface DpCreationSelectOptionProps {
	createRelease: (systemNode: StructureDto, name: string) => Promise<any>
	inputValue: string
	isReleaseLoading: boolean
	setIsReleaseLoading: React.Dispatch<React.SetStateAction<boolean>>
	systemNode: StructureDto | undefined
}

const DpCreationSelectOption = ({
	systemNode,
	inputValue,
	isReleaseLoading,
	setIsReleaseLoading,
	createRelease,
}: DpCreationSelectOptionProps) => {
	const { t } = useAppContext()

	return (
		<div className="flex gap-4 items-center ml-3 justify-between">
			{<span>{t('CREATE_DEPLOYMENT_PACKAGE', [inputValue])}</span>}
			<Button
				style={{ height: '24px', marginRight: '6px' }}
				isLoading={isReleaseLoading}
				onClick={() => {
					setIsReleaseLoading(true)

					createRelease(systemNode as StructureDto, inputValue)
				}}
			>
				{t('CREATE')}
			</Button>
		</div>
	)
}

export default DpCreationSelectOption
